import React, { useState } from 'react';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ProjectDrawer from '@components/Project/ProjectDrawer';
import ProjectTitle from '@components/Project/ProjectTitle';
import TransactionEvent from '@components/Transactions/TransactionEvent';

const Wrapper = styled.div`
    .transaction-description {
        font-size: ${(props) => props.theme.FontSizeSm};
    }
`;

const StatementProjectCell = ({ row, project, showEvent = false }) => {
    const statementProject = project || row.Project || row.Transaction?.Project;
    const [projectPreviewID, setProjectPreviewID] = useState(null);

    const openProjectPreview = () => {
        setProjectPreviewID(statementProject.ID);
    };
    const closeProjectPreview = () => {
        setProjectPreviewID(null);
    };

    return (
        <Wrapper className="transaction-middle">
            <div className="project-details">
                {row.Transaction?.ServiceID && (
                    <p className="transaction-client">{getContactName(row.Transaction.ServiceID)}</p>
                )}
                {showEvent ? (
                    <TransactionEvent transaction={row.Transaction} project={statementProject} />
                ) : (
                    statementProject && (
                        <ProjectTitle project={statementProject} compact linkToProject={openProjectPreview} />
                    )
                )}
            </div>
            {row.Transaction?.Description && (
                <div className="transaction-description">{row.Transaction.Description}</div>
            )}
            {row.Description && row.Description !== row.Transaction?.Description && (
                <div className="transaction-description">{row.Description}</div>
            )}
            {projectPreviewID && <ProjectDrawer projectId={projectPreviewID} onClose={closeProjectPreview} />}
        </Wrapper>
    );
};

export default StatementProjectCell;
